import { NppesSearch, NppesPhysician } from "../models/PhysicianDetails";
import { rules } from "../utils/validation/Validation";
import { PhysicianNameCol, PhysicianNpiCol, SelectPhysicianBtn } from "../components/styles/styles";
import { colors } from "../styles/colors";
import fontWeight from "../styles/mui/fontWeight";
import { TableBody, TableHead } from "./FormComponents";

export enum GetNPPESDataActionDispatchTypes {
  GET_NPPES_DATA_INVOKE = "GET_NPPES_DATA_INVOKE",
  GET_NPPES_DATA_SUCCESS = "GET_NPPES_DATA_SUCCESS",
  GET_NPPES_DATA_RESET = "GET_NPPES_DATA_RESET",
}

export enum PhysicianDetailsDetailsHeader {
  NPI = "NPI:",
  PHYSICIAN_NAME = "Physician Name:",
}

export const primaryPhysicianFormNames = {
  physicianName: "physicianDetails.primaryPhysician.physicianName",
  physicianNpiId: "physicianDetails.primaryPhysician.physicianNpiId",
  phoneNo: "physicianDetails.primaryPhysician.phoneNo",
  phoneExt: "physicianDetails.primaryPhysician.phoneExt",
  taxId: "physicianDetails.primaryPhysician.taxId",
  address: [
    "physicianDetails.primaryPhysician.streetName1",
    "physicianDetails.primaryPhysician.streetName2",
    "physicianDetails.primaryPhysician.city",
    "physicianDetails.primaryPhysician.county",
    "physicianDetails.primaryPhysician.physicianState",
    "physicianDetails.primaryPhysician.zipCode",
    "physicianDetails.primaryPhysician.latitude",
    "physicianDetails.primaryPhysician.longitude",
  ],
  fax: "physicianDetails.primaryPhysician.fax",
};

export const NPPESinitialRecord = {
  name: "",
  npiId: "",
  address: "",
  phoneNo: "",
  taxId: "",
  phoneExt: "",
  county: "",
  streetName1: "",
  streetName2: "",
  fax: "",
  city: "",
  state: "",
  zipCode: "",
};

export const nppesInitialRecord: NppesSearch[] = [
  NPPESinitialRecord,
];


export enum NppesApiCall {
  BY_NPI = "byNpi",
  BY_NAME = "byName",
}

export const physicianNames = {
  ordering: "orderingPhysicianPhysicianName",
  primary: "primaryPhysicianPhysicianName",
  referralSourcePhysician: "referralSourcePhysicianName",
  following: "followingPhysicianName",
};

export const physicianFormProps = (physicianFormName: string) => {
  if (physicianFormName === physicianNames.primary) {
    return {
      physicianName: "Physician Name: ",
      physicianNpi: "NPI: ",
      rule: rules.physicianName,
    };
  }
  if (physicianFormName === physicianNames.referralSourcePhysician) {
    return {
      physicianName: "Facility Name: ",
      physicianNpi: "NPI: ",
      rule: rules.facilityName,
    };
  }
  if (physicianFormName === physicianNames.following) {
    return {
      physicianName: "Physician Name: ",
      physicianNpi: "NPI: ",
      rule: rules.physicianName,
    };
  }
  return {
    physicianName: "Ordering Physician Name",
    physicianNpi: "Ordering Physician NPI: ",
    rule: rules.orderingPrescriber,
  };
};

export const physicianInitialData: NppesPhysician = {
  physicianName: "",
  physicianNpiId: "",
  phoneExt: "",
  phoneNo: "",
  streetName1: "",
  streetName2: "",
  fax: "",
  county: "",
  city: "",
  physicianState: "",
  zipCode: "",
  physicianAddress: "",
};

export enum TableDropdown {
  SERVICE_PROVIDER = "SERVICE_PROVIDER",
  PHYSICIAN = "PHYSICIAN",
}
const gridSize = [4, 2, 4, 2];

const physicianTableHeadKeys = [
  "physicianName",
  "physicianNpi",
  "physicianAddress",
  "action",
];

const physicianTableBodyKeys = [
  "physicianName",
  "physicianNpiId",
  "physicianAddress",
  "CHOOSE",
];

const serviceProviderTableHeadKeys = [
  "providerName",
  "providerNpi",
  "physicianAddress",
  "action",
];

const serviceProviderTableBodyKeys = [
  "providerName",
  "providerNpi",
  "providerAddress",
  "CHOOSE",
];

const tableHead: TableHead[] = [
  {
    label: "Name:",
    key: "",
    style: { textAlign: "left", paddingLeft: "1rem" },
    type: "body1",
    color: colors.black[14],
    fontWeight: fontWeight[5],
    xs: gridSize[0],
  },
  {
    label: "NPI Number:",
    key: "",
    style: { textAlign: "center" },
    type: "body1",
    color: colors.black[14],
    fontWeight: fontWeight[5],
    xs: gridSize[1],
  },
  {
    label: "Address:",
    key: "",
    style: { textAlign: "left", paddingLeft: "1rem" },
    type: "body1",
    color: colors.black[14],
    fontWeight: fontWeight[5],
    xs: gridSize[2],
  },
  {
    label: "Action:",
    key: "",
    style: { textAlign: "center" },
    type: "body1",
    color: colors.black[14],
    fontWeight: fontWeight[5],
    xs: gridSize[3],
  },
];

const tableBody: TableBody[] = [
  {
    key: "",
    style: PhysicianNameCol,
    type: "subtitle2",
    color: colors.black[4],
    fontWeight: fontWeight[4],
    xs: gridSize[0],
  },
  {
    key: "",
    style: PhysicianNpiCol,
    type: "subtitle2",
    color: colors.black[4],
    fontWeight: fontWeight[4],
    xs: gridSize[1],
  },
  {
    key: "",
    style: PhysicianNameCol,
    type: "subtitle2",
    color: colors.black[4],
    fontWeight: fontWeight[4],
    xs: gridSize[2],
  },
  {
    key: "",
    style: SelectPhysicianBtn,
    type: "subtitle2",
    color: colors.black[4],
    fontWeight: fontWeight[4],
    xs: gridSize[3],
  },
];

export const getTableHead = (table: TableDropdown) => {
  switch (table) {
    case TableDropdown.SERVICE_PROVIDER:
      return tableHead.map((head, index) => {
        head.key = serviceProviderTableHeadKeys[index];
        return head;
      });
    case TableDropdown.PHYSICIAN:
      return tableHead.map((head, index) => {
        head.key = physicianTableHeadKeys[index];
        return head;
      });
  }
  return [];
};

export const getTableBody = (tab: TableDropdown) => {
  switch (tab) {
    case TableDropdown.SERVICE_PROVIDER:
      return tableBody.map((body, index) => {
        body.key = serviceProviderTableBodyKeys[index];
        return body;
      });
    case TableDropdown.PHYSICIAN:
      return tableBody.map((body, index) => {
        body.key = physicianTableBodyKeys[index];
        return body;
      });
  }
  return [];
};

export const NppesType = {
  PhysicianOffice: "4",
  Others: "2"
};

export const nppesPhysicianErrorMsg = "Last Name or First name is required.";
export const nppesOrganizationErrorMsg = "Organization name is required.";

export const getNppesTypeDetails = (type: string) => {
  const nppesTypeDetails = { name: "lastName", placeHolder: "Enter Last Name", title: "Search by Name/State" };
  if (type !== NppesType.PhysicianOffice) {
    nppesTypeDetails.name = "organizationName";
    nppesTypeDetails.placeHolder = "Enter Organization";
    nppesTypeDetails.title = "Search by Organization Name/State"
  }
  return nppesTypeDetails;
};

export const fieldsMap = [
  { key: "physicianName" },
  { key: "physicianNpiId" },
  { key: "fax" },
  { key: "phoneNo" },
  { key: "phoneExt" },
  { key: "streetName1" },
  { key: "streetName2" },
  { key: "county" },
  { key: "city" },
  { key: "physicianState" },
  { key: "zipCode" },
  { key: "latitude" },
  { key: "longitude" },
];

export enum PhysicianTypeID {
  DEFAULT = 0,
  PRIMARY = 1,
  ORDERING = 2,
  FOLLOWING = 3,
}

export const fieldNames = [
  "physicianDetails.primaryPhysician.physicianName",
  "physicianDetails.primaryPhysician.physicianNpiId",
  "physicianDetails.primaryPhysician.phoneNo",
  "physicianDetails.primaryPhysician.streetName1",
  "physicianDetails.primaryPhysician.county",
  "physicianDetails.primaryPhysician.zipCode",
  "physicianDetails.primaryPhysician.taxId",
  "physicianDetails.primaryPhysician.fax",
  "physicianDetails.primaryPhysician.streetName2",
  "physicianDetails.primaryPhysician.physicianState",
  "physicianDetails.primaryPhysician.city",
];